import { __decorate } from "tslib";
// @ts-ignore eventbus is specified in the app instead of packages
import { EventBus } from '@/plugins/event-bus';
import { QIcon, QItem, QItemLabel, QItemSection, QList } from 'quasar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ESensor, ESetPoint } from '../../types';
let RoomInfoCard = class RoomInfoCard extends Vue {
    constructor() {
        super(...arguments);
        this.sensors = ESensor;
    }
    emitRoutPush(roomid) {
        EventBus.$emit('roomDetail', {
            route: this.$route,
            roomId: roomid,
        });
    }
    getIconInfo(mode) {
        switch (mode.toLowerCase()) {
            case `heating low`:
                return ['local_fire_department', 'orange-3', 1];
            case `heating medium`:
                return ['local_fire_department', 'orange-4', 2];
            case `heating high`:
                return ['local_fire_department', 'deep-orange-5', 3];
            case `cooling low`:
                return ['ac_unit', 'light-blue-3', 1];
            case `cooling medium`:
                return ['ac_unit', 'light-blue-5', 2];
            case `cooling high`:
                return ['ac_unit', 'light-blue-9', 3];
            case `off`:
            default:
        }
        return [];
    }
    getMinMaxTemp() {
        if (!this.room?.current_setpoints?.[ESetPoint.MinTemperature]) {
            return 'Geen setpoints';
        }
        if (!this.room?.current_setpoints?.[ESetPoint.MaxTemperature]) {
            return 'Geen setpoints';
        }
        const unit = this.$t('roomText.units.Temperature');
        return `${this.room.current_setpoints[ESetPoint.MinTemperature]}${unit} - ` +
            `${this.room.current_setpoints[ESetPoint.MaxTemperature]}${unit}`;
    }
    currentSensors(sensor) {
        if (this.room && this.room.current_sensors && this.room.current_sensors[sensor]) {
            return this.room.current_sensors[sensor].toFixed(1);
        }
        return '-';
    }
};
__decorate([
    Prop({ required: true, type: Object })
], RoomInfoCard.prototype, "room", void 0);
RoomInfoCard = __decorate([
    Component({
        components: {
            QItemSection,
            QItemLabel,
            QList,
            QItem,
            QIcon,
        },
    })
], RoomInfoCard);
export default RoomInfoCard;
